// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stat_wrapper__24zCO","title":"Stat_title__1jPhy","number":"Stat_number___2peG"};